import React, { useEffect, useState } from 'react'
import {
  Form,
  Input,
  Select,
  Switch,
  Button,
  Card,
  Row,
  Col,
  Typography,
  Modal,
  message,
  Space,
  InputNumber,
} from 'antd'
import { UserOutlined, PhoneOutlined, LockOutlined } from '@ant-design/icons'
import './Common.module.css'
import styles from './Common.module.css'
import { clearAllCookies } from '../../../../util/handleObject'
import { PointsRecargeRatio } from '../../../../util/constants'
import { editPointRequest } from '../api'

const { TextArea } = Input
const Common = (props) => {
  const [form] = Form.useForm()
  const [rechargeAmount, setRechargeAmount] = useState('')
  const [presentPoints, setPresentPoints] = useState('')
  const [beizhu, setBeizhu] = useState('')
  const [messageApi, contextHolder] = message.useMessage()

  useEffect(() => {
    console.log("内容信息--------"+props.info)
    console.log(props.info)
      if(props.openStatus){
        form.resetFields()
        form.setFieldsValue({
          rechargeAmount: props.info.jiage,
          presentPoints: props.info.zengsong_jifen,
          beizhu: props.info.beizhu,
        })
        setRechargeAmount(props.info.jiage)
        setPresentPoints(props.info.zengsong_jifen)
        setBeizhu(props.info.beizhu)
      }
      
    }, [props.openStatus]) // 空数组意味着这个 effect 只会在组件挂载时执行一次
  const formatter = (value) => {
    const [start, end] = `${value}`.split('.') || []
    const v = `${start}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return `${end ? `${v}.${end}` : `${v}`}`
  }
  const parse = (value) => value.replace(/\D/g, '') || undefined // 移除非数字字符或返回 undefined

  const onFinish = (values) => {
    editPointRequest(
      rechargeAmount,
      rechargeAmount * 100,
      presentPoints,
      beizhu,
      props.info.Id,
      (data) => {
        console.log(data)
        if (data.ret === '1') {
          message.success('更新成功', 1)
          props.updateData()
          closeCommon()
        } else {
          message.error('更新失败', 1)
        }
      }
    )
  }

  const closeCommon = () => {
    props.closeCommonModal()
  }

  return (
    <Modal
      maskClosable={false}
      // visible={true}
      open={props.openStatus}
      onCancel={closeCommon}
      footer={null} // 设置 footer 为 null 移除默认按钮
      width={800}
      // className="add-account-container"
    >
      {contextHolder}
      <Card className={styles['form-card']} span={20}>
        <div className={styles['form-title']}>充值额度设置</div>
        <Form
          layout="horizontal"
          form={form}
          onFinish={onFinish}
          className="account-form"
        >
          <Form.Item
            label="充值金额"
            name="rechargeAmount"
            rules={[{ required: true, message: '请输入充值金额' }]}
            labelAlign="right"
            labelCol={{ span: 5 }}
          >
            <InputNumber
              min={1}
              max={10000}
              prefix="￥"
              formatter={(value) => formatter(value)} // 格式化输入值
              parser={(value) => parse(value)} // 解析输入值
              style={{ width: '100%' }}
              placeholder="请输入自定义金额"
              value={rechargeAmount}
              onChange={(value) => {
                if (value < 1 || value == null) {
                  message.error('请输入大于1的金额')
                  return
                }
                setRechargeAmount(value)
              }}
            />
          </Form.Item>

          <Form.Item
            label="等价兑换积分"
            name="equivalentPoints"
            rules={[{ required: false, message: '请输入等价兑换积分' }]}
            labelAlign="right"
            labelCol={{ span: 5 }}
          >
            <div>{rechargeAmount * PointsRecargeRatio} 积分</div>
          </Form.Item>
          <Form.Item
            label="赠送积分"
            name="presentPoints"
            rules={[{ required: true, message: '请输入赠送积分' }]}
            labelAlign="right"
            labelCol={{ span: 5 }}
          >
            <InputNumber
              min={0}
              max={10000}
              prefix=""
              // formatter={(value) => formatter(value)} // 格式化输入值
              // parser={(value) => parse(value)} // 解析输入值
              style={{ width: '100%' }}
              placeholder="请输入赠送积分"
              value={presentPoints}
              onChange={(value) => {
                if (value < 0 || value == null) {
                  message.error('请输入大于等于0的金额')
                  return
                }
                setPresentPoints(value)
              }}
            />
          </Form.Item>

          <Form.Item
            label="实际到账积分"
            name="actualPoints"
            rules={[{ required: false, message: '请输入实际到账积分' }]}
            labelAlign="right"
            labelCol={{ span: 5 }}
          >
            <div>{parseInt(rechargeAmount * PointsRecargeRatio) + parseInt(presentPoints)} 积分</div>
          </Form.Item>
          
          <Form.Item
            label="备注"
            name="beizhu"
            labelAlign="right"
            labelCol={{ span: 5 }}
          >
            <TextArea
              placeholder="输入备注信息"
              value={beizhu}
              onChange={(e) => {
                setBeizhu(e.target.value)
              }}
            />
          </Form.Item>
          <Form.Item className={styles['form-actions']}>
            <Button
              size="large"
              onClick={(e) => {
                setBeizhu('')
                setRechargeAmount('')
                setPresentPoints('')
                closeCommon()
              }}
            >
              取消
            </Button>

            <Button
              type="primary"
              htmlType="submit"
              size="large"
              style={{ marginLeft: 16 }}
            >
              确认
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </Modal>
  )
}

export default Common

